import { AiChatRepositoryImpl } from '@/data/repositories/ai-chat-repository-impl.js';
import type { AiChatRepository } from '@/domain/repositories/ai-chat-repository.js';
import { EventSourceClient } from '@/infra/http/event-source-client.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';

export const makeAiChatRepository = (httpClient: FetchHttpClient): AiChatRepository => new AiChatRepositoryImpl(httpClient, new EventSourceClient());
